import { render, staticRenderFns } from "./Columns.vue?vue&type=template&id=0014cf64"
import script from "./Columns.vue?vue&type=script&lang=js"
export * from "./Columns.vue?vue&type=script&lang=js"
import style0 from "./Columns.vue?vue&type=style&index=0&id=0014cf64&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports